<template>
  <f7-page>
    <f7-navbar title="設定 Email 登入" back-link="back">
      <f7-nav-right>
        <f7-link @click="confirm">確認</f7-link>
      </f7-nav-right>
    </f7-navbar>

    <f7-list media-list>
      <f7-list-item ref="email">
        <f7-label floating>帳號 (Email):</f7-label>
        <f7-input type="text" placeholder="" :value="email" @input="email = $event.target.value" @focus="onFocus('email')" clear-button />
      </f7-list-item>
      <f7-list-item ref="password">
        <f7-label floating>新密碼:</f7-label>
        <f7-input type="password" placeholder="" :value="password" @input="password = $event.target.value" @focus="onFocus('password')" clear-button />
      </f7-list-item>
      <f7-list-item ref="confirmPassword">
        <f7-label floating>請再次輸入密碼:</f7-label>
        <f7-input type="password" placeholder="" :value="confirmPassword" @input="confirmPassword = $event.target.value" @focus="onFocus('confirmPassword')" clear-button />
      </f7-list-item>
    </f7-list>
  </f7-page>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data () {
    return {
      email: null,
      password: null,
      confirmPassword: null
    }
  },
  methods: {
    ...mapActions('userModule', ['linkEmail']),
    onFocus (field) {
      this.$refs[field].$el.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
    },
    confirm () {
      if (this.password === this.confirmPassword) {
        this.$f7.dialog.alert('您所要操作的為高安全性資料，請再次登入您的帳號', '帳號驗證', async () => {
          this.$f7.dialog.progress('正在更新，請稍待...')
          await this.linkEmail({ email: this.email, password: this.password })
          this.$utils.nextFrame(() => this.$f7.dialog.close())
          this.$f7.notification.create({
            title: '更新完成',
            text: '請至所填的 Eamil 信箱點選認證信件內的連結',
            closeOnClick: true,
            closeButton: true
          }).open()
          this.$f7router.back()
        })
      } else {
        this.$f7.dialog.alert('請重新輸入密碼', '密碼不相同')
      }
    }
  }
}
</script>
